module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_02-6cde57bea5cf3237544395b46d957fa4.svg";